<cm-add-item-dialog [title]="'New material'" [confirmDisabled]="!$validatedInputData()" [isLoading]="$isLoading()" (confirm)="onConfirm()">
    <ng-container cm-dialog-content>
        @if (!$isBatchMode()) {
            <div class="cm-add-material-name">
                <cm-input-container>
                    <ng-container cm-inline-label> Name:</ng-container>
                    <ng-container cm-input>
                        <cm-string-input [value]="$data().name" (valueChange)="updateData({name: $event})"></cm-string-input>
                    </ng-container>
                </cm-input-container>
            </div>
        }
        @if ($can().read.menu("extendedCreate")) {
            <cm-organization-select
                class="cm-add-material-organization"
                [updateOrganization]="updateOrganization.bind(this)"
                [organizationId]="$data().organizationId ?? null"
                [showIfViewedByOwner]="false"
                [showLabel]="false"
                [usedInAddEntityContext]="true"
            ></cm-organization-select>
        }

        @if ($materialRangeTags(); as materialRangeTags) {
            @if (materialRangeTags.length > 0) {
                <mat-form-field appearance="outline" class="cm-add-material-range">
                    <mat-select [value]="$data().materialRangeTagId" (valueChange)="updateData({materialRangeTagId: $event})" placeholder="Material range">
                        <mat-option [value]="undefined">{{ "" }}</mat-option>
                        @for (rangeTag of materialRangeTags; track rangeTag.id) {
                            <mat-option [value]="rangeTag.id">{{ rangeTag.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        } @else {
            @if ($can().read.menu("extendedCreate")) {
                <cm-placeholder [dark]="true" class="cm-add-material-range"></cm-placeholder>
            }
        }

        @if (!$isBatchMode()) {
            <div class="cm-add-material-details">
                @for (method of $createMethods(); track method) {
                    <button
                        class="cm-text-button cm-left-panel-option"
                        (click)="updateData({createMethod: method.id})"
                        [class.cm-selected]="$data().createMethod === method.id"
                    >
                        <i [class]="'far ' + method.icon"></i>
                        {{ method.label }}
                    </button>
                }
            </div>

            <div class="cm-add-material-info">
                @switch ($data().createMethod) {
                    @case ("BLANK") {
                        <cm-hint>
                            <ng-container cm-text> Use this option to scan or create a material from <b>scratch</b>.</ng-container>
                        </cm-hint>
                    }
                    @case ("FROM_IMAGE") {
                        <cm-hint>
                            <ng-container cm-text> Create a material from an <b>image</b>.</ng-container>
                        </cm-hint>
                        <cm-drop-files
                            [enableDrop]="true"
                            [maxFiles]="1"
                            [accept]="Accept.Images"
                            [showDropzone]="!$data().pbrFiles?.get(TextureType.Diffuse)?.file"
                            [subtitle]="'Click to browse for files.'"
                            (filesDropped)="updatePbrImage({textureType: TextureType.Diffuse, file: $event[0]})"
                        >
                            <div>
                                <img
                                    class="cm-image-thumbnail"
                                    [src]="$data().pbrFiles?.get(TextureType.Diffuse)?.imageUrl"
                                    alt="Thumbnail of image to upload"
                                />
                                <button
                                    class="cm-image-thumbnail-button cm-button cm-remove"
                                    (click)="updatePbrImage({textureType: TextureType.Diffuse, file: undefined})"
                                >
                                    <i class="far fa-trash"></i>
                                </button>
                            </div>
                        </cm-drop-files>
                        <mat-form-field appearance="outline" class="cm-add-texture-color-space">
                            <mat-select
                                [value]="$data().pbrFiles?.get(TextureType.Diffuse)?.colorSpace || ImageColorSpace.Srgb"
                                (valueChange)="updatePbrImage({textureType: TextureType.Diffuse, colorSpace: $event})"
                                placeholder="Color space"
                            >
                                @for (imageColorSpace of ImageColorSpaceLabels.values(); track imageColorSpace.state) {
                                    <mat-option [value]="imageColorSpace.state">{{ imageColorSpace.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <cm-input-container>
                            <ng-container cm-inline-label> Width:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input
                                    [value]="$data().width"
                                    [decimalPlaces]="2"
                                    (valueChange)="updateData({width: $event ?? undefined})"
                                    placeholder="Width in cm"
                                />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container>
                            <ng-container cm-inline-label> Height:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input
                                    [value]="$data().height"
                                    [decimalPlaces]="2"
                                    (valueChange)="updateData({height: $event ?? undefined})"
                                    placeholder="Height in cm"
                                />
                            </ng-container>
                        </cm-input-container>
                    }
                    @case ("FROM_IMAGE_AI") {
                        <cm-hint>
                            <ng-container cm-text> Create a material from an image using <b> Material AI </b>.</ng-container>
                        </cm-hint>
                        <cm-drop-files
                            [enableDrop]="true"
                            [maxFiles]="1"
                            [accept]="Accept.Images"
                            [showDropzone]="!$data().pbrFiles?.get(TextureType.Diffuse)?.file"
                            [subtitle]="'Click to browse for files.'"
                            (filesDropped)="updatePbrImage({textureType: TextureType.Diffuse, file: $event[0]})"
                        >
                            <div>
                                <img
                                    class="cm-image-thumbnail"
                                    [src]="$data().pbrFiles?.get(TextureType.Diffuse)?.imageUrl"
                                    alt="Thumbnail of image to upload"
                                />
                                <button
                                    class="cm-image-thumbnail-button cm-button cm-remove"
                                    (click)="updatePbrImage({textureType: TextureType.Diffuse, file: undefined})"
                                >
                                    <i class="far fa-trash"></i>
                                </button>
                            </div>
                        </cm-drop-files>
                        <mat-form-field appearance="outline" class="cm-add-texture-color-space">
                            <mat-select
                                [value]="$data().pbrFiles?.get(TextureType.Diffuse)?.colorSpace || ImageColorSpace.Srgb"
                                (valueChange)="updatePbrImage({textureType: TextureType.Diffuse, colorSpace: $event})"
                                placeholder="Color space"
                            >
                                @for (imageColorSpace of ImageColorSpaceLabels.values(); track imageColorSpace.state) {
                                    <mat-option [value]="imageColorSpace.state">{{ imageColorSpace.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <cm-input-container>
                            <ng-container cm-inline-label> Width:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input
                                    [value]="$data().width"
                                    [decimalPlaces]="2"
                                    (valueChange)="updateData({width: $event ?? undefined})"
                                    placeholder="Width in cm"
                                />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container>
                            <ng-container cm-inline-label> Height:</ng-container>
                            <ng-container cm-input>
                                <cm-numeric-input
                                    [value]="$data().height"
                                    [decimalPlaces]="2"
                                    (valueChange)="updateData({height: $event ?? undefined})"
                                    placeholder="Height in cm"
                                />
                            </ng-container>
                        </cm-input-container>
                        <cm-checkbox [value]="$data().materialAiIgnoreDpi" (valueChange)="$data.set({...$data(), materialAiIgnoreDpi: $event})">
                            <ng-container> Ignore DPI </ng-container>
                        </cm-checkbox>
                        <mat-form-field appearance="outline" class="cm-add-texture-material-ai-tags">
                            <mat-select (selectionChange)="setSelectedMaterialAiTags($event.value)" placeholder="Add tag" multiple>
                                <mat-select-trigger> Add tag </mat-select-trigger>
                                @for (tag of MaterialAiTagLabels.values(); track tag.state) {
                                    <mat-option [value]="tag.state">{{ tag.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="cm-selected-tag-list">
                            @for (tag of $data().materialAiTags; track tag) {
                                <div (click)="removeMaterialAiTag(tag)" class="cm-selected-tag">
                                    <i class="fa-solid fa-xmark"></i>
                                    <div [matTooltip]="MaterialAiTagLabels.get(tag)?.label" class="cm-selected-tag-name">
                                        {{ MaterialAiTagLabels.get(tag)?.label?.split(":")?.[1] }}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @case ("FROM_PBR_FILES") {
                        <cm-hint>
                            <ng-container cm-text>
                                Create a material by uploading <b>PBR maps</b>. You will be able to upload the files in the next step.</ng-container
                            >
                        </cm-hint>
                    }
                    @default {
                        <span class="cm-add-material-info-text">Select a method to create a material.</span>
                    }
                }
            </div>
        }
    </ng-container>
</cm-add-item-dialog>
